import React, { useEffect, useState } from "react";
import "./styles.scss";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import axios from "../../../api/axiosService";
import { sanitize, getLocalized } from "../../../Common/Util";

export default function Award({ ...props }) {
  const { i18n } = useTranslation();
  const [data, setData] = useState({});

  const fetchData = async () => {
    try {
      const response = await axios.get(`/api/award/list?artistId=${props.id}`);
      setData(response.data.data);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    if (props.id) fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="award-tab">
      {_.isObject(data) && (
        <div className="content">
          <div className="award-list">
            {data?.length > 0 &&
              data.map((value) => (
                <div
                  key={value.id}
                  className="flex flex-col mb-[50px] md:mb-[30px] award-item"
                >
                  <div className="md:flex flex-col md:justify-between md:items-start info w-full ">
                    <p
                      className="mb-[5px] w-full"
                      dangerouslySetInnerHTML={sanitize(
                        getLocalized(value, "title", i18n.language),
                      )}
                    />
                  </div>
                  {_.get(value, "image") && (
                    <img
                      className="object-cover w-full aspect-square self-center"
                      src={_.get(value, "image")}
                      alt={_.get(value, "image")}
                    />
                  )}
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}
